
var headroom;

 document.addEventListener('DOMContentLoaded', function() {
  var announcement = document.querySelector('.special-announcement-container');
  var closeButton = document.querySelector('.special-announcement-close');
  var header = document.querySelector('.header');
  var headroom;
  var resizeTimer;
  var offset = 0;

  function updateAnnouncementOffset() {
    var announcementHeight = 0;
    var headerHeight = header ? header.offsetHeight : 0;

    if (
      announcement &&
      !announcement.classList.contains('is-closed') &&
      !announcement.classList.contains('is-closing')
    ) {
      announcementHeight = announcement.offsetHeight;
    }

    
    offset = announcementHeight;

    if (header) {
      //header.style.top = announcementHeight + 'px';
    }

    document.documentElement.style.setProperty(
      '--header-total-offset',
      (announcementHeight + headerHeight) + 'px'
    );

    return offset;
  }

  function initHeadroom() {
    if (!header) return;

    updateAnnouncementOffset();

    if (headroom) {
      headroom.destroy();
    }

    headroom = new Headroom(header, {
      offset: offset,
      tolerance: {
        up: 10,
        down: 10
      }
    });

    headroom.init();
  }

  initHeadroom();

  window.addEventListener('load', function() {
    initHeadroom();
  });

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function() {
      initHeadroom();
    }, 150);
  });

  if (window.ResizeObserver && announcement) {
    var observer = new ResizeObserver(function() {
      if (!announcement.classList.contains('is-closing') && !announcement.classList.contains('is-closed')) {
        initHeadroom();
      }
    });

    observer.observe(announcement);
  }

  if (closeButton && announcement) {
    closeButton.addEventListener('click', function() {
      announcement.classList.add('is-closing');

      window.setTimeout(function() {
        announcement.classList.remove('is-closing');
        announcement.classList.add('is-closed');

        if (header) {
          //header.style.top = '0px';
        }

        // Refresh ScrollTrigger so other animation stuff still works.
        if (window.ScrollTrigger) {
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              ScrollTrigger.refresh();
            });
          });
        }

        document.documentElement.style.setProperty(
          '--header-total-offset',
          (header ? header.offsetHeight : 0) + 'px'
        );

        if (headroom) {
          headroom.destroy();
        }

        headroom = new Headroom(header, {
          offset: 0,
          tolerance: {
            up: 10,
            down: 10
          }
        });

        headroom.init();
      }, 400);
    });
  }
});


/*
jQuery(document).ready(function () {

  var offset = 0;
  var myElement = document.querySelector("header");
  // construct an instance of Headroom, passing the element
  headroom = new Headroom(myElement, {
    offset: offset,
    tolerance: {
      down: 11,
      up: 3,
    },
    scroller : '.wrapper',
    // callback when pinned, `this` is headroom object
    onPin: function () {
      jQuery("html").addClass("hr--pinned");
    },
    // callback when unpinned, `this` is headroom object
    onUnpin: function () {
      jQuery("html").removeClass("hr--pinned");
    }
  });
  // initialise
  headroom.init();
});
*/



(function () {
  function runHeroWordAnim() {
    var h1 = document.querySelector(".home-hero h1");
    if (!h1) return;

    var text = (h1.textContent || h1.innerText || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) return;

    var words = text.split(" ");
    var html = "";
    for (var i = 0; i < words.length; i++) {
      html +=
        '<span class="word">' +
        words[i] +
        "</span>" +
        (i < words.length - 1 ? " " : "");
    }
    h1.innerHTML = html;

    if (typeof TweenMax !== "undefined") {
      TweenMax.set(h1, { opacity: 1 });
    } else {
      h1.style.opacity = "1";
      h1.style.visibility = "visible";
    }

    
    var nodeList = h1.querySelectorAll(".word");
    var spans = [];
    for (var j = 0; j < nodeList.length; j++) {
      spans.push(nodeList[j]);
      nodeList[j].style.display = "inline-block";
    }

    if (typeof TweenMax === "undefined" || typeof TimelineMax === "undefined")
      return;

    TweenMax.killTweensOf(spans);
    TweenMax.set(spans, { autoAlpha: 0, y: 16 });

    var tl = new TimelineMax();
    tl.staggerTo(
      spans,
      0.7,
      { autoAlpha: 1, y: 0, ease: Power3.easeOut, overwrite: "auto" },
      0.06
    );
  }

  // Run after everything is loaded (more reliable on WP), and also on next paint
  document.addEventListener("DOMContentLoaded", function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(runHeroWordAnim);
    });
  });
})();


// Scroll pin + crossfade feature
document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn("GSAP/ScrollTrigger not loaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var media = document.querySelector(".scroll-block1 .col-first .inner");
  var section2 = document.querySelector(".scroll-block2");
  var header = document.querySelector(".headroom");

  if (!media || !section2) return;

  var img1 = media.querySelector("img.img1");
  var img2 = media.querySelector("img.img2");
  if (!img1 || !img2) return;

  // Ensure initial visibility states
  gsap.set(img1, { autoAlpha: 1 });
  gsap.set(img2, { autoAlpha: 0 });

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function headerH() {
    return header ? header.offsetHeight : 0;
  }

  function docTop(el) {
    var r = el.getBoundingClientRect();
    return r.top + scrollY();
  }

  function calcDistance() {
    var s2Anchor = section2.querySelector(".container-fluid") || section2;

    var mediaH = media.getBoundingClientRect().height;
    var mediaTop = docTop(media);

    var s2Top = docTop(s2Anchor);
    var s2H = section2.getBoundingClientRect().height;

    var targetTop = s2Top + (s2H - mediaH) / 2;
    var dist = targetTop - mediaTop;

    return dist > 0 ? dist : 0;
  }

  // Pin behavior (unchanged)
  ScrollTrigger.create({
    trigger: media,
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    pin: media,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true
  });

  // Crossfade scrub over same scroll range
  ScrollTrigger.create({
    trigger: media,
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    scrub: true,
    invalidateOnRefresh: true,
    onUpdate: function (self) {
      // crossfade centered around halfway
      var center = 0.5;
      var halfWindow = 0.12; // fade spans ~0.38 -> ~0.62
      var t = (self.progress - (center - halfWindow)) / (2 * halfWindow);

      if (t < 0) t = 0;
      if (t > 1) t = 1;

      gsap.set(img1, { autoAlpha: 1 - t });
      gsap.set(img2, { autoAlpha: t });
    }
  });

  function refreshAll() {
    ScrollTrigger.refresh();
  }

  // Refresh after images load (important for correct heights)
  if (!img1.complete) img1.addEventListener("load", refreshAll);
  if (!img2.complete) img2.addEventListener("load", refreshAll);

  window.addEventListener("resize", refreshAll);
  ScrollTrigger.refresh();
});



// Animate projects list page
// Animate FacetWP grid items
document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap) {
    console.warn("GSAP not found");
    return;
  }

  var itemSelector = ".facetwp-template > [class*='col-']";

  function animateFacetwpItems() {
    var items = document.querySelectorAll(itemSelector);
    if (!items || !items.length) return;

    gsap.killTweensOf(items);
    gsap.set(items, { autoAlpha: 0, y: 18 });

    function runAnimation() {
      gsap.to(items, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        stagger: { each: 0.07, from: "start" }
      });
    }

    if (window.imagesLoaded) {
      imagesLoaded(items, function () {
        runAnimation();
      });
    } else {
      runAnimation();
    }
  }

  jQuery(function () {
    animateFacetwpItems();
  });

  jQuery(document).on("facetwp-loaded", function () {
    setTimeout(function () {
      animateFacetwpItems();
    }, 0);
  });
});




// Put this in a global JS file or inline (footer is fine)
document.addEventListener("DOMContentLoaded", function () {
document.addEventListener('facetwp-loaded', function () {
  // Close all fSelect dropdowns
  if (typeof fUtil !== 'undefined') {
    fUtil('.facetwp-type-fselect .facetwp-dropdown').each(function () {
      // FacetWP attaches the fSelect instance to the dropdown node
      if (this.fselect && typeof this.fselect.close === 'function') {
        this.fselect.close();
      }
    });
  } else {
    // Fallback if fUtil isn't available for some reason
    var els = document.querySelectorAll('.facetwp-type-fselect .facetwp-dropdown');
    for (var i = 0; i < els.length; i++) {
      if (els[i].fselect && typeof els[i].fselect.close === 'function') {
        els[i].fselect.close();
      }
    }
  }
});
});


document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  // Target each slider instance
  document.querySelectorAll(".projects-client-slider .swiper").forEach(function (swiperEl) {
    var slides = swiperEl.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    // Set initial state (in case CSS didn't load yet)
    gsap.set(slides, { autoAlpha: 0, y: 16 });

    ScrollTrigger.create({
      trigger: swiperEl,
      start: "top 80%",
      once: true,
      onEnter: function () {
        gsap.to(slides, {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          ease: "power3.out",
          stagger: 0.08,
          clearProps: "transform"
        });
      }
    });
  });
});



// Swiper progress bullet feature.
function restartActiveBulletAnimation(swiper) {
  var bullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
  if (!bullets.length) return;

  // Remove animation by toggling a class is messy; easiest is reflow trick:
  bullets.forEach(function (b) {
    // remove animation by forcing it to reset
    b.classList.remove('is-animating');
  });

  var active = swiper.el.querySelector('.swiper-pagination-bullet-active');
  if (!active) return;

  // Force reflow then re-add class to restart animation
  // (works even if the same bullet becomes active again)
  void active.offsetWidth;
  active.classList.add('is-animating');
}




// Social media pin by hero slider
window.addEventListener('load', function() {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  var slider = document.querySelector('.slider.hero-slider');
  var stickyWrap = document.querySelector('.slider-rail__sticky');

  if (!slider || !stickyWrap) return;

  ScrollTrigger.create({
    trigger: slider,
    start: 'top top+=140',
    end: 'bottom top+=420',
    pin: stickyWrap,
    pinSpacing: false,
    markers: false
  });
});






// Auto image slideshow.
document.addEventListener("DOMContentLoaded", function () {
function initSlideshow(container) {
    var inner = container.querySelector(".inner");
    if (!inner) return;

    var imgs = inner.querySelectorAll("img");
    if (!imgs || imgs.length < 2) return;

    if (inner.offsetHeight === 0) {
      inner.style.minHeight = "320px";
    }

    // Config
    var displayMs = 3200;  // time between slide changes
    var fadeMs = 900;      // crossfade duration
    var zoomFrom = 1.02;
    var zoomTo = 1.10;

    // Prep
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].style.opacity = "0";
      imgs[i].style.transform = "scale(" + zoomFrom + ")";
      imgs[i].style.willChange = "opacity, transform";
      imgs[i].style.pointerEvents = "none";
    }

    var current = 0;
    var resetTimers = new WeakMap();

    function clearResetTimer(img) {
      var t = resetTimers.get(img);
      if (t) {
        clearTimeout(t);
        resetTimers.delete(img);
      }
    }

    function activate(img) {
      clearResetTimer(img);

      // Start from zoomFrom, then zoom up while visible
      img.style.transition = "none";
      img.style.transform = "scale(" + zoomFrom + ")";
      img.offsetHeight; // reflow

      img.style.transition =
        "opacity " + fadeMs + "ms ease, transform " + displayMs + "ms linear";
      img.style.opacity = "1";
      img.style.transform = "scale(" + zoomTo + ")";
    }

    function deactivate(img) {
      clearResetTimer(img);

      // Fade out ONLY. Do NOT change transform here (prevents the shrink snap).
      img.style.transition = "opacity " + fadeMs + "ms ease";
      img.style.opacity = "0";

      // After fade completes, reset zoom so it's ready next time (invisible reset)
      var timer = setTimeout(function () {
        img.style.transition = "none";
        img.style.transform = "scale(" + zoomFrom + ")";
      }, fadeMs + 30);

      resetTimers.set(img, timer);
    }

    function showInitial() {
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].style.transition = "none";
        imgs[k].style.opacity = "0";
        imgs[k].style.transform = "scale(" + zoomFrom + ")";
      }
      inner.offsetHeight;

      activate(imgs[current]);
    }

    function next() {
      var prev = current;
      current = (current + 1) % imgs.length;

      activate(imgs[current]); // fades/zooms in
      deactivate(imgs[prev]);  // fades out without transform snap
    }

    // Start after first image is ready
    if (imgs[0].complete) {
      showInitial();
    } else {
      imgs[0].addEventListener("load", showInitial, { once: true });
    }

    setInterval(next, displayMs);
  }

  function boot() {
    var slideshows = document.querySelectorAll(".image-auto-slideshow");
    for (var i = 0; i < slideshows.length; i++) {
      initSlideshow(slideshows[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
});





jQuery(document).ready(function () {
(function ($) {
  $('.slider.hover-links').each(function () {
    var slider = this;
    var swiperEl = slider.querySelector('.swiper-container');

    if (!swiperEl || !swiperEl.swiper) {
      return;
    }

    slider.addEventListener('mousemove', function (e) {
      var isClickable = $(e.target).closest('a, button, .swiper-button-prev, .swiper-button-next, .swiper-pagination').length;

      var rect = slider.getBoundingClientRect();
var x = e.clientX - rect.left;
var y = e.clientY - rect.top;

slider.style.setProperty('--cursor-x', x + 'px');
slider.style.setProperty('--cursor-y', y + 'px');

      if (isClickable) {
        slider.classList.remove('hover-left', 'hover-right');
        slider.classList.add('hover-link');
        return;
      }

      slider.classList.remove('hover-link');

      var rect = slider.getBoundingClientRect();
      var x = e.clientX - rect.left;

      slider.classList.toggle('hover-left', x < rect.width / 2);
      slider.classList.toggle('hover-right', x >= rect.width / 2);
    });

    slider.addEventListener('mouseleave', function () {
      slider.classList.remove('hover-left', 'hover-right', 'hover-link');
    });

    slider.addEventListener('click', function (e) {
      if ($(e.target).closest('a, button, .swiper-button-prev, .swiper-button-next, .swiper-pagination').length) {
        return;
      }

      var rect = slider.getBoundingClientRect();
      var x = e.clientX - rect.left;

      if (x < rect.width / 2) {
        swiperEl.swiper.slidePrev();
      } else {
        swiperEl.swiper.slideNext();
      }
    });
  });
})(jQuery);

});

